/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import T from 'prop-types'
import { injectIntl } from 'react-intl'
import { Button } from '@material-ui/core'
import { loginWithMicrosoft } from 'reducers/auth/reducer'
import withPromise from 'helpers/withPromise'
import messages from './translate'

const MSAL_CDN_URL =
  'https://alcdn.msauth.net/browser/2.32.0/js/msal-browser.js'

const MICROSOFT_SCOPES = ['openid', 'profile', 'email', 'User.Read']

const MISSING_CLIENT_ID_MESSAGE =
  'REACT_APP_MICROSOFT_CLIENT_ID is missing from window._env. Add it to .env, run "pnpm start" (or "npx react-env"), then hard-refresh the browser.'

const getMicrosoftRedirectUri = () =>
  `${window.location.origin}/microsoft-auth.html`

class LoginWithMicrosoft extends Component {
  static propTypes = {
    loginWithMicrosoft: T.func.isRequired,
  }

  state = {
    isAuthenticating: false,
  }

  msalInstance = null

  componentDidMount() {
    if (window.msal) {
      this.initAuth()

      return
    }

    const script = document.createElement('script')
    script.src = MSAL_CDN_URL
    script.async = true
    script.defer = true
    script.onload = this.initAuth
    script.onerror = () => {
      console.error('Failed to load Microsoft authentication library')
    }
    document.head.appendChild(script)
  }

  initAuth = () => {
    const clientId = window._env.REACT_APP_MICROSOFT_CLIENT_ID

    if (!clientId) {
      console.error(MISSING_CLIENT_ID_MESSAGE)

      return
    }

    if (!window.msal) {
      console.error('Microsoft authentication library is not available')

      return
    }

    this.msalInstance = new window.msal.PublicClientApplication({
      auth: {
        clientId,
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: getMicrosoftRedirectUri(),
      },
    })
  }

  completeLogin = response =>
    withPromise(this.props.loginWithMicrosoft, {
      provider: 'microsoft',
      access_token: response.accessToken,
      id_token: response.idToken,
    })

  microsoftLogIn = () => {
    if (!window._env.REACT_APP_MICROSOFT_CLIENT_ID) {
      console.error(MISSING_CLIENT_ID_MESSAGE)

      return
    }

    if (!this.msalInstance) {
      this.initAuth()
    }

    if (!this.msalInstance) {
      console.error('Microsoft auth is not initialized')

      return
    }

    this.setState({ isAuthenticating: true })

    this.msalInstance
      .loginPopup({
        scopes: MICROSOFT_SCOPES,
        prompt: 'select_account',
      })
      .then(response => this.completeLogin(response))
      .catch(error => {
        console.error(`Authorize error: ${error}`)
      })
      .finally(() => {
        this.setState({ isAuthenticating: false })
      })
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props
    const { isAuthenticating } = this.state

    return (
      <div className="login-with-microsoft">
        <Button
          fullWidth
          href={null}
          type="button"
          size="large"
          color="default"
          variant="contained"
          className="MuiButton-microsoft-login"
          onClick={this.microsoftLogIn}
          disabled={isAuthenticating}>
          <img
            src="/assets/images/microsoft-icon.svg"
            className="microsoft-login-icon"
            alt="Microsoft"
          />
          {formatMessage(messages.login_microsoft)}
        </Button>
      </div>
    )
  }
}

const enhance = connect(null, { loginWithMicrosoft })

export default enhance(injectIntl(LoginWithMicrosoft))
